<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="700px"
      :title="$l('dialog_title_rejectReason') || '驳回原因'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :amzPurchaseChangeCode="amzPurchaseChangeCode"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.rejected()">
          {{ $l('INDEX.btn_rejected') || '驳回' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzPurchaseChangeCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
